import type { DiaCalendario } from '../pages/relatorio-civel-page.models';

const NOMES_SEMANA = ['1ª Semana', '2ª Semana', '3ª Semana', '4ª Semana', '5ª Semana', '6ª Semana'];

/** Rótulo da linha da semana no calendário de comparecimento. */
export function nomeSemanaCalendario(index: number): string {
  return NOMES_SEMANA[index] || `${index + 1}ª Semana`;
}

/**
 * Matriz de semanas (domingo a sábado) do mês, completando as bordas com os
 * dias do mês anterior e posterior (marcados como `isMesAtual: false`).
 */
export function gerarCalendarioMensal(mes: string, ano: number): (DiaCalendario | null)[][] {
  const mesNum = parseInt(mes) - 1; // JavaScript usa mês 0-indexed
  const primeiroDia = new Date(ano, mesNum, 1);
  const ultimoDia = new Date(ano, mesNum + 1, 0);
  const diasNoMes = ultimoDia.getDate();
  const diaDaSemanaInicio = primeiroDia.getDay(); // 0 = Domingo

  const mesAnterior = mesNum === 0 ? 11 : mesNum - 1;
  const anoAnterior = mesNum === 0 ? ano - 1 : ano;
  const diasNoMesAnterior = new Date(anoAnterior, mesAnterior + 1, 0).getDate();

  const mesPosterior = mesNum === 11 ? 0 : mesNum + 1;
  const anoPosterior = mesNum === 11 ? ano + 1 : ano;

  const semanas: (DiaCalendario | null)[][] = [];
  let semanaAtual: (DiaCalendario | null)[] = [];

  let diaAnterior = diasNoMesAnterior - diaDaSemanaInicio + 1;
  for (let i = 0; i < diaDaSemanaInicio; i++) {
    semanaAtual.push({
      dia: diaAnterior,
      mes: String(mesAnterior + 1).padStart(2, '0'),
      ano: anoAnterior,
      isMesAtual: false,
    });
    diaAnterior++;
  }

  // mes/ano normalizados para todas as linhas do mês corrente
  const mesNorm = String(mes).padStart(2, '0');
  const anoNorm = Number(ano);
  for (let dia = 1; dia <= diasNoMes; dia++) {
    semanaAtual.push({
      dia,
      mes: mesNorm,
      ano: anoNorm,
      isMesAtual: true,
    });
    if (semanaAtual.length === 7) {
      semanas.push(semanaAtual);
      semanaAtual = [];
    }
  }

  if (semanaAtual.length > 0) {
    let diaPosterior = 1;
    while (semanaAtual.length < 7) {
      semanaAtual.push({
        dia: diaPosterior,
        mes: String(mesPosterior + 1).padStart(2, '0'),
        ano: anoPosterior,
        isMesAtual: false,
      });
      diaPosterior++;
    }
    semanas.push(semanaAtual);
  }

  return semanas;
}
